<template>
    <div v-if="result" class="thanks-basket">
        <h2 class="thanks-basket__title">
            {{ messages.yourOrder }}
        </h2>
        <div
            v-if="result.order"
            class="thanks-basket__items"
        >
            <ThanksProduct
                v-for="item in result.order.items"
                :key="item.offer && item.offer.id || item.id"
                :result="item"
                :messages="messages"
            />
        </div>
    </div>
</template>

<script>
import ThanksProduct from "./ThanksProduct";
export default {
    name: 'ThanksBasket',
    props: ['result'],
    components: {
        ThanksProduct,
    },
    computed: {
        messages() {
            return this.result?.order?.messages;
        }
    }
}
</script>

<style lang="scss" scoped>
.thanks-basket{
    &__title{
        font-weight: 500;
        font-size: 16px;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        margin-bottom: 24px;
        @include point-lg{
            font-size: 18px;
        }
    }
    &__items{
        display: grid;
        grid-row-gap: 12px;
    }
}
</style>